import { useNavigate, useLocation } from "react-router-dom";

interface ReferralNavigationButtonProps {
  className?: string;
  children: React.ReactNode;
  disabled?: boolean;
}

export function ReferralNavigationButton({
  className,
  children,
  disabled,
}: ReferralNavigationButtonProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (disabled) return;
    navigate("/refer");
  };

  const isDisabled = disabled || location.pathname === "/refer";

  return (
    <button
      className={className}
      onClick={handleClick}
      type="button"
      disabled={isDisabled}
    >
      {children}
    </button>
  );
}
